import { Model } from '../general'

export interface FloorplanPosition {
  x: number
  y: number
}

export interface FloorplanScale {
  start: FloorplanPosition
  end: FloorplanPosition
  distance: number
}

export interface FloorplanPlacementData {
  element_id?: number
  position?: {
    x: number
    y: number
    rotation: number
  }
}

export interface FloorplanWorkspaceData extends FloorplanPlacementData {
  id: number
  workspace_type_id?: number
  name?: string
}

export interface Data {
  id: number
  company_id: number
  building_id: number
  number?: number
  name?: string
  floorplan?: {
    background?: string
    scale?: FloorplanScale
    published?: boolean
  }
  workspaces?: FloorplanWorkspaceData[]
}

class Floorplan extends Model<Data> {
  get name() {
    return this.data.name
  }
  get number() {
    return this.data.number
  }

  get background() {
    return this.data.floorplan?.background
  }

  get scale() {
    return this.data.floorplan?.scale
  }

  get workspaces() {
    return this.data.workspaces
  }

  get isPublished() {
    return this.data.floorplan?.published
  }
}

export default Floorplan
